var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Select = dynamicRequire('Select.jsx');
var Mssg = dynamicRequire('Mssg.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');

class Wheels extends React.Component {

    render() {
        let selectKey = this.props.wheels.reduce((prev, wheel) => {return wheel.partName + prev}, '');
        return <div className="lr-casefactory-choices-options-option option clearfix">
            <Mssg __key="nc_casefactory.rolls" /><br />
            <Select
                key={selectKey}
                className="lr-style"
                choiceHandler = {(value) => {
                    this.context.emitter.emit('rollsOrWheels', this.getWheel(value))
                }}
                active={this.props.wheelId || ''}
                options={this.getWheelOptions(this.props.wheels)}
            />
        </div>
    }

    getWheelOptions(wheels) {
        var options = wheels.map((wheel) => {
            var label = wheel.partName ? wheel.partName : resolveLanguage("nc_casefactory.part.name." + wheel.articleNumber)
            return {
                value: wheel.id,
                name: label
            }
        })

        if (!this.props.isDoubleDoorRack) {
            options = [{name: resolveLanguage('nc_casefactory.no.wheels'), value: ''}, ...options]
        }

        return options;
    }

    getWheel(value) {
        var wheelCandidates = this.props.wheels.filter((wheel)=>{
            return wheel.id == value;
        });

        if(wheelCandidates.length){
            return wheelCandidates[0];
        }else{
            return null;
        }
    }
}

Wheels.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = Wheels;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Wheels.jsx